<template>
  <div>
    <!--    标题部分-->
    <div class="h-title">
      <div>充电桩管理</div>
    </div>
    <!--    地图-->
    <div class="map">
      <baidu-map :style="style" :center="center" :zoom="zoom" scroll-wheel-zoom @ready="handler">
        <bm-marker :position="center"></bm-marker>
        <bm-overlay
            pane="labelPane"
            :class="{sample: true}"
            @draw="draw">
          <div>昌华智慧工业园</div>
        </bm-overlay>
      </baidu-map>
      <!--      电桩信息-->
      <div class="info">
        <div class="info_item" v-for="item in pileList" :key="item.id">
          <div>
            <img :src="item.icon" alt="">
          </div>
          <div class="info_item_counts">
            <p :style="'color: ' + item.color" style="font-size: 25rem; font-weight: bold">{{ item.counts }}</p>
            <p>{{ item.name }}</p>
          </div>
        </div>
      </div>
    </div>
    <!--    电桩-->
    <div class="piles">
      <!--      搜索栏-->
      <div class="search">
        <el-input
            style="width: 60%; margin-right: 15rem"
            v-model="inputValue"
            placeholder="请输入充电桩型号"
            @keyup.enter.native="handleSearch"
            clearable/>
        <el-button type="primary" @click="handleSearch">
          搜索
        </el-button>
        <el-button @click="handleReset">
          重置
        </el-button>
      </div>
      <!--      电桩列表-->
      <div class="piles_box">
        <el-card class="box-card" v-for="item in piles2" :key="item.id">
          <div style="position: relative">
            <img src="./images/cdz.png">
            <div class="icon">
              {{ !!item.speed ? '快' : '慢' }}
            </div>
          </div>
          <div class="piles_box_item">
            <p style="height: 40rem; font-weight: 600; font-size: 22rem">{{ item.name }}</p>
            <p>设备类型：{{ item.type }}</p>
            <p>充电接口：{{ item.ele === 1 ? '直流' : '交流' }}</p>
            <p>充电次数：{{ item.counts }}次</p>
            <p>剩余时长：{{ item.time }}</p>
            <p>计费单价：{{ item.price }}元/度</p>
          </div>
          <div class="piles_box_status">
            <p
                style="
                text-align: right;
              "
                :style="'color: ' + item.color"
            >
              {{ item.status === 0 ? '空闲' : '使用中' }}
            </p>
            <p>
              <i class="el-icon-location-information" @click="() => {
                this.zoom = 17
              }"></i>
            </p>
          </div>
        </el-card>
      </div>
    </div>
  </div>
</template>

<script>
import pileSnowIcon from "../Chargingpile/images/03.png";
import pileQuickIcon from "../Chargingpile/images/04.png";
import pileIcon from "../Chargingpile/images/05.png";

export default {
  data() {
    return {
      style: {
        width: 100 + '%',
        height: 100 + '%',
      },
      center: {lng: 0, lat: 0},
      zoom: 17,
      pileList: [
        {
          id: Math.random() * +new Date(),
          icon: pileSnowIcon,
          counts: 9,
          name: '交流电桩',
          color: 'rgb(30, 145, 230)'
        }, {
          id: Math.random() * +new Date(),
          icon: pileQuickIcon,
          counts: 0,
          name: '直流电桩',
          color: 'rgb(30, 145, 230)'
        }, {
          id: Math.random() * +new Date(),
          icon: pileIcon,
          counts: 0,
          name: '离线（枪）',
          color: 'rgb(204, 204, 204)'
        }, {
          id: Math.random() * +new Date(),
          icon: pileIcon,
          counts: 0,
          name: '故障（枪）',
          color: 'rgb(253, 52, 42)'
        },
      ],
      // 充电桩列表
      piles: [
        {
          id: 0,
          speed: 0, // 1 快 0 慢
          name: '枪号DL300-1',
          type: '一体式充电机',
          ele: 0, // 0 直流 1 交流
          counts: 125,
          time: '02:18:45',
          price: 1.23,
          status: 1, // 状态 0 空闲 1 使用中
          color: '#5ad8a6'
        }, {
          id: 1,
          speed: 0, // 1 快 0 慢
          name: '枪号DL300-2',
          type: '一体式充电机',
          ele: 0, // 0 直流 1 交流
          counts: 57,
          time: '03:09:01',
          price: 1.23,
          status: 0, // 状态 0 空闲 1 使用中
          color: '#999'
        }, {
          id: 2,
          speed: 0, // 1 快 0 慢
          name: '枪号DL300-3',
          type: '一体式充电机',
          ele: 0, // 0 直流 1 交流
          counts: 103,
          time: '06:17:34',
          price: 1.23,
          status: 0, // 状态 0 空闲 1 使用中
          color: '#999'
        }, {
          id: 3,
          speed: 0, // 1 快 0 慢
          name: '枪号DL300-4',
          type: '一体式充电机',
          ele: 0, // 0 直流 1 交流
          counts: 98,
          time: '07:01:45',
          price: 1.23,
          status: 0, // 状态 0 空闲 1 使用中
          color: '#999'
        }, {
          id: 4,
          speed: 0, // 1 快 0 慢
          name: '枪号DL300-5',
          type: '一体式充电机',
          ele: 0, // 0 直流 1 交流
          counts: 221,
          time: '04:19:45',
          price: 1.23,
          status: 0, // 状态 0 空闲 1 使用中
          color: '#999'
        }, {
          id: 5,
          speed: 0, // 1 快 0 慢
          name: '枪号DL300-6',
          type: '一体式充电机',
          ele: 0, // 0 直流 1 交流
          counts: 128,
          time: '08:18:12',
          price: 1.23,
          status: 0, // 状态 0 空闲 1 使用中
          color: '#999'
        }, {
          id: 6,
          speed: 0, // 1 快 0 慢
          name: '枪号DL300-7',
          type: '一体式充电机',
          ele: 0, // 0 直流 1 交流
          counts: 29,
          time: '06:05:49',
          price: 1.23,
          status: 0, // 状态 0 空闲 1 使用中
          color: '#999'
        },{
          id: 6,
          speed: 0, // 1 快 0 慢
          name: '枪号DL300-8',
          type: '一体式充电机',
          ele: 0, // 0 直流 1 交流
          counts: 106,
          time: '08:32:42',
          price: 1.23,
          status: 0, // 状态 0 空闲 1 使用中
          color: '#999'
        },{
          id: 6,
          speed: 0, // 1 快 0 慢
          name: '枪号DL300-9',
          type: '一体式充电机',
          ele: 0, // 0 直流 1 交流
          counts: 87,
          time: '08:12:01',
          price: 1.23,
          status: 0, // 状态 0 空闲 1 使用中
          color: '#999'
        }
      ],
      piles2: [],
      inputValue: ''
    }
  },
  created() {
    this.piles2 = this.piles
  },
  methods: {
    draw ({el, BMap, map}) {
      const pixel = map.pointToOverlayPixel(new BMap.Point(114.144838, 30.464757))
      el.style.left = pixel.x - 60 + 'px'
      el.style.top = pixel.y - 20 + 'px'
    },
    handler({BMap, map}) {
      this.center.lng = 114.150354
      this.center.lat = 30.470982
    },
    handleSearch() {
      this.piles2 = this.piles.filter((item) => {
        return item.name.indexOf(this.inputValue) >= 0
      })
    },
    handleReset() {
      this.inputValue = ''
      this.piles2 = this.piles
    }
  }
}
</script>
<style lang="less" scoped>
* {
  box-sizing: border-box;
}

.h-title {
  height: 4vh;
  border-bottom: 1px solid rgba(0, 0, 0, .15);
  font-size: 20rem;
  font-weight: 600;
  margin-bottom: 1vh;
}

.map {
  height: 37vh;
  position: relative;
  overflow: hidden;

  .info {
    position: absolute;
    top: 20rem;
    left: 20rem;

    .info_item {
      width: 240rem;
      height: 20%;
      display: flex;
      justify-content: space-between;
      align-items: center;
      background-color: #fff;
      margin-bottom: 8rem;
      border-radius: 10rem;
      padding: 10rem;

      .info_item_counts {
        text-align: right;
      }
    }
  }
}

.piles {
  height: 58vh;

  .search {
    width: 40%;
    height: 10%;
    display: flex;
    align-items: center;
  }

  .piles_box {
    padding-top: 10rem;
    width: 100%;
    height: 80%;
    display: flex;
    flex-wrap: wrap;
    overflow-y: auto;


    .box-card {
      width: calc(33.33% - 10rem);
      height: calc(50% - 10rem);
      margin: 5rem 5rem;

      ::v-deep .el-card__body {
        display: flex;
        justify-content: space-between;
      }

      img {
        width: 90px;
        height: 90px;
      }

      .icon {
        position: absolute;
        top: 0;
        width: 30rem;
        height: 30rem;
        background-color: #ff9822;
        color: #FFFFFF;
        text-align: center;
        line-height: 30rem;
        border-radius: 50%;
      }

      .piles_box_item {
        margin-left: 5rem;

        p {
          height: 25rem;
        }
      }

      .piles_box_status {
        display: flex;
        flex-direction: column;
        justify-content: space-between;
        text-align: right;
      }

    }
  }
}

.sample {
  width: 200px;
  height: 40px;
  line-height: 40px;
  overflow: hidden;
  color: #269a99;
  font-size: 20px;
  text-align: center;
  font-weight: 500;
  padding: 10px;
  position: absolute;
}

</style>